import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import type { IResponseInboxCombine } from 'entities/Inbox/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventInboxUpdate = () => {
  const { inboxesStore, websocket } = useEntitiesContext()
  const InboxUpdated = (data: IResponseInboxCombine) => {
    inboxesStore.addItem(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.InboxUpdated, InboxUpdated), [])
}
